import _ from 'lodash';
import React, { Component } from 'react';
import { Row, Col, Button } from 'react-bootstrap';

import Uuid from '../../../../support/Uuid';
import ConceptosList from './conceptos/ConceptosList';
import TotalGlobalSummary from './TotalGlobalSummary';
import ConceptoUpsertForm from './conceptos/ConceptoUpsertForm';
import TipoComprobante from '../../support/enum/TipoComprobante';
import ConceptoBaseCalculator from '../../support/impuestos/ConceptoBaseCalculator';
import SuggestionsRefManager from '../../../catalogs/support/SuggestionsRefManager';
import ComprobanteImpuestosCalculator from '../../support/impuestos/ComprobanteImpuestosCalculator';

class ConceptosManager extends Component {

  state = {
    editing: undefined
  }

  get items() {
    const { data } = this.props;

    return !!data.Conceptos && !!data.Conceptos.Concepto ? data.Conceptos.Concepto : [];
  }

  handleOnItemUpsert = (item) => {
    const { data } = this.props;
    const originalItems = this.items;

    const traslados = [item.TrasladosIva, item.TrasladosIeps].filter(impuesto => !!impuesto);
    const retenciones = [item.RetencionesIsr, item.RetencionesIva, item.RetencionesIeps].filter(impuesto => !!impuesto && !!impuesto.TipoFactor);

    const importe = (new ConceptoBaseCalculator(item)).getNeto();

    let impuestos = {};

    if (traslados.length > 0) {
      impuestos.Traslados = {
        Traslado: traslados
      }
    }

    if (retenciones.length > 0) {
      impuestos.Retenciones = {
        Retencion: retenciones
      };
    }

    let newItem = {
      id: Uuid.v4(),
      ...item,
      ClaveProdServ: item.ClaveProdServ || '01010101',
      ClaveUnidad: item.ClaveUnidad || 'XNA',
      Unidad: item.Unidad || 'No disponible',
      Importe: importe,
      Impuestos: impuestos,
      TrasladosIva: undefined,
      TrasladosIeps: undefined,
      RetencionesIsr: undefined,
      RetencionesIva: undefined,
      RetencionesIeps: undefined
    };

    if (TipoComprobante.make(data.TipoDeComprobante).isTraslado()) {
      newItem.Impuestos = undefined;
    }

    const items = originalItems.concat([newItem]);

    let comprobante = {
      ...data,
      Conceptos: {
        Concepto: [
          ...items
        ]
      }
    };

    let updated = (new ComprobanteImpuestosCalculator(comprobante))
      .apply()
      .get()

    this.props.onChange({
      ...updated
    });

    for (const ref of SuggestionsRefManager.all()) {
      ref.ref.current.clear();
    }
  }

  handleOnAddFile = (dataFile) => {
    const { data } = this.props;
    const originalItems = this.items;

    let newData = _.map(dataFile, (item) => {
      item.id = Uuid.v4();

      return item;
    });

    const items = originalItems.concat(newData);

    let comprobante = {
      ...data,
      Conceptos: {
        Concepto: [
          ...items
        ]
      }
    };

    let updated = (new ComprobanteImpuestosCalculator(comprobante))
      .apply()
      .get()

    this.props.onChange({
      ...updated
    });
  }

  handleOnConceptosDelete = (conceptos) => {
    const { data } = this.props;

    let comprobante = {
      ...data,
      Conceptos: {
        Concepto: [
          ...conceptos
        ]
      }
    };

    let updated = (new ComprobanteImpuestosCalculator(comprobante))
      .apply()
      .get()

    this.props.onChange({
      ...updated
    });
  }

  handleOnConceptoEdit = (item) => {
    const { data } = this.props;

    this.setState({
      editing: item
    });

    const items = this.items;

    let comprobante = {
      ...data,
      Conceptos: {
        Concepto: [
          ...items.filter((value) => value.id !== item.id)
        ]
      }
    };

    let updated = (new ComprobanteImpuestosCalculator(comprobante))
      .apply()
      .get()

    this.props.onChange({
      ...updated
    });

    setTimeout(() => {
      this.setState({
        editing: undefined
      });
    }, 500);
  }

  handleOnDelete = () => {
    const { data } = this.props;

    let comprobante = {
      ...data,
      Conceptos: {
        Concepto: []
      }
    };

    this.props.onChange({
      ...comprobante
    });
  }

  render() {
    const { autoFocus, data } = this.props;
    const { editing } = this.state;

    return (
      <>
        <div className="pb-3">
          <ConceptoUpsertForm
            autoFocus={ autoFocus }
            data={ editing }
            comprobante={ data }
            onUpsert={ this.handleOnItemUpsert }
            onAdd={ this.handleOnAddFile }
          />
        </div>

        <div className="pb-3">
          <ConceptosList
            data={ this.items }
            onDelete={ this.handleOnConceptosDelete }
            onEdit={ this.handleOnConceptoEdit }
          />
        </div>

        <Row>
          <Col sm md={ 6 }>
            <Button variant="danger"
              disabled={ this.items.length === 0 }
              onClick={ this.handleOnDelete }
            >
              Eliminar conceptos
            </Button>
          </Col>
          <Col sm md={ 6 }>
            <TotalGlobalSummary data={ data } />
          </Col>
        </Row>
      </>
    )
  }
}

export default ConceptosManager;